/* eslint-disable eqeqeq */
import { EditOutlined, PlusOutlined, QuestionCircleOutlined, InboxOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  Divider,
  Flex,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Typography,
  message,
  Tooltip,
  Upload,
  Tabs,
  Spin,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { LuLayoutDashboard } from "react-icons/lu";
import Skeleton from "react-loading-skeleton";
import CheckMark from "../../assets/check.svg";
import { makeApiRequest } from "../../shared/api";
import { v4 as uuidv4 } from 'uuid';
import styles from "./style.module.scss";
import axios from 'axios';
// import { log } from "@antv/g2plot/lib/utils";
const { TabPane } = Tabs;
const { Dragger } = Upload;

const { Title, Text } = Typography;
const fileTypeMap = {
  "application/pdf": "pdf",
  "text/plain": "txt",
  "text/html": "html",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "docx",
};

const ContentKB = ({ KB_ID, FACEBOT_ID }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [, setIsEditing] = useState({});
  const [kbData, setKbData] = useState(null);
  const [content, setContent] = useState({});
  const [originalContent, setOriginalContent] = useState({});
  const [categories, setCategories] = useState([]);
  const [isProcessingModalVisible, setIsProcessingModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All Categories");
  const [approvedItems, setApprovedItems] = useState({});
  const [activeKeys, setActiveKeys] = useState([]);
  const [isApproving, setIsApproving] = useState({});
  const [form] = Form.useForm();
  const [questions, setQuestions] = useState({});
  const [originalQuestions, setOriginalQuestions] = useState({});
  const [openAddQuestionModal, setOpenAddQuestionModal] = useState(false);
  const [newCategory, setNewCategory] = useState('');
  const [isDeleting, setIsDeleting] = useState({});
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const [newlyAddedQuestions, setNewlyAddedQuestions] = useState([]);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [additionalInfoForm] = Form.useForm();
  const [isAdditionalInfoModalVisible, setIsAdditionalInfoModalVisible] = useState(false);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);
  const [additionalInfoContent, setAdditionalInfoContent] = useState({});
  const [fileList, setFileList] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [activeTab, setActiveTab] = useState('single');
  const [kbName, setKbName] = useState('');
  const [kbDescription, setKbDescription] = useState('');
  const [kbType, setKbType] = useState('');
  const [kbStatus, setKbStatus] = useState('');
  const [kbProgress, setKbProgress] = useState('');


  const cardItems = [
    {
      title: "Categories",
      value: categoriesLoaded ? categories.length : 0,
      icon: <LuLayoutDashboard size={20} />,
    },
    {
      title: "Questions",
      value: kbData?.kb_answers?.length || 0,
      icon: <FaRegQuestionCircle size={20} />,
    },
  ];
  const onChange = (value) => {
    setSelectedCategory(value === undefined ? null : value);
  };


  const handleCollapseChange = (keys) => {
    setActiveKeys(keys);
  };

  const handleApproveAll = async() => {
    if (!selectedCategory) {
      message.error("Please select a category to approve.");
      return;
    }

    try {
      setIsLoading(true);

      let kb_answers_to_approve = kbData?.kb_answers || [];

      if (selectedCategory !== "All Categories") {
        kb_answers_to_approve = kb_answers_to_approve.filter(
          (item) =>
            item.question_category === selectedCategory
        );
      }

      if (!kb_answers_to_approve || kb_answers_to_approve.length === 0) {
        const msg = selectedCategory === "All Categories"
          ? "No questions found in the knowledge base to approve."
          : `No questions found in category: ${selectedCategory} to approve.`;
        message.warning(msg);
        setIsLoading(false);
        return;
      }

      const payload = kb_answers_to_approve
        .filter(item => {
          // Only include items that need approval (either never approved or edited since approval)
          const hasBeenEdited = (content[item.question_index] !== originalContent[item.question_index]) ||
                                  (questions[item.question_index] !== originalQuestions[item.question_index]);
          const needsApproval = !approvedItems[item.question_index] || hasBeenEdited;
          return needsApproval;
        })
        .map((item) => ({
          question_index: item.question_index,
          question_text: questions[item.question_index] ?? item.question_text,
          answer_text: content[item.question_index] ?? item.answer_text,
          question_category: item.question_category,
          status: "Approved",
        }));


      if(payload.length === 0) {
        message.info("No items require approval in the selected category.");
        setIsLoading(false);
        return;
      }

      const response = await makeApiRequest(
        "PUT",
        `kb/${KB_ID}/questions`,
        payload
      );

      if (response) {
        const successMsg = selectedCategory === "All Categories"
          ? `Successfully approved ${payload.length} question(s).`
          : `Successfully approved ${payload.length} question(s) in category: ${selectedCategory}`;
        message.success(successMsg);

        const updatedApprovedItems = { ...approvedItems };
        const updatedOriginalContent = { ...originalContent };
        const updatedOriginalQuestions = { ...originalQuestions };

        payload.forEach((approvedItem) => {
          updatedApprovedItems[approvedItem.question_index] = true;
          // Update originals to reflect the newly approved state
          updatedOriginalContent[approvedItem.question_index] = approvedItem.answer_text;
          updatedOriginalQuestions[approvedItem.question_index] = approvedItem.question_text;
        });

        setApprovedItems(updatedApprovedItems);
        setOriginalContent(updatedOriginalContent);
        setOriginalQuestions(updatedOriginalQuestions);

        // GetKb();
      } else {
        const errorMsg = selectedCategory === "All Categories"
          ? "Failed to approve all questions."
          : `Failed to approve questions in category: ${selectedCategory}.`;
        message.error(errorMsg);
      }
    } catch (error) {
      console.error("Approve All Error:", error);
      message.error("An error occurred while approving the category.");
    } finally {
      setIsLoading(false);
    }
  };

  const options = [...categories, "All Categories"]?.map((category) => ({
    label: category,
    value: category,
  }));

  const handleTextChange = (question_index, newText) => {
    setContent((prev) => ({
      ...prev,
      [question_index]: newText,
    }));

    setApprovedItems((prev) => {
      if (prev[question_index]) {
        const { [question_index]: removed, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  };

  useEffect(() => {
    const fetchKBDetails = async () => {
      try {
        const response = await makeApiRequest("GET", `kb/${KB_ID}`);
        console.log(response, "response");
        if (response) {
          setKbName(response.kb_name || '');
          setKbDescription(response.kb_description || '');
          setKbType(response.kb_type || '');
        }
      } catch (error) {
        console.error('Error fetching KB details:', error);
      }
    };
  
    if (KB_ID) {
      fetchKBDetails();
    }
  }, [KB_ID]);

  const handleQuestionChange = (question_index, newQuestion) => {
    setQuestions((prev) => ({
      ...prev,
      [question_index]: newQuestion,
    }));

    setApprovedItems((prev) => {
      if (prev[question_index]) {
        const { [question_index]: removed, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  };

  const handleApprove = async(item) => {
    try {
      setIsApproving((prev) => ({ ...prev, [item.question_index]: true }));
      const answer = content[item.question_index] ?? item.answer_text;
      const question = questions[item.question_index] ?? item.question_text;

      const response = await makeApiRequest("PUT", `/kb/${item.kb_id}/questions/${item.question_index}`, {
        question_text: question,
        answer_text: answer,
        question_category: item.question_category,
        status: "Approved",
        layout_id: "HTML_LAYOUT_01",
        additional_info: additionalInfoContent[item.question_index] || null
      });

      if (response) {
        message.success("Successfully approved question");
        setApprovedItems((prev) => ({ ...prev, [item.question_index]: true }));

        setOriginalContent(prev => ({...prev, [item.question_index]: answer}));
        setOriginalQuestions(prev => ({...prev, [item.question_index]: question}));
        setNewlyAddedQuestions((prev) =>
          prev.map((q) =>
            q.question_index === item.question_index
              ? { ...q, status: "Approved" }
              : q
          )
        );
        if (kbData?.kb_answers) {
          setKbData((prev) => ({
            ...prev,
            kb_answers: prev.kb_answers.map((q) =>
              q.question_index === item.question_index
                ? { ...q, status: "Approved" }
                : q
            ),
          }));
        }
      } else {
        message.error("Failed to approve question");
      }
    } catch (error) {
      console.error("Approve Error:", error);
      message.error("An error occurred while approving the question.");
    } finally {
      setIsApproving((prev) => ({ ...prev, [item.question_index]: false }));
    }
  };

  const getQuestionStatusCounts = () => {
    const allQuestions = [
      ...(kbData?.kb_answers || []),
      ...newlyAddedQuestions,
    ];
    const createdCount = allQuestions.filter((item) => {
      // Check if the item is unapproved or has pending changes
      const hasBeenEdited =
        content[item.question_index] !== originalContent[item.question_index] ||
        questions[item.question_index] !==
          originalQuestions[item.question_index];
      return (
        item.status === "Created" ||
        !approvedItems[item.question_index] ||
        hasBeenEdited
      );
    }).length;

    return {
      total: allQuestions.length,
      created: createdCount,
    };
  };

  const handleUnapprovedClick = () => {
    setIsConfirmModalVisible(true);
  };
  const checkAllEffectivelyApproved = () => {
    const allQuestions = [
      ...(kbData?.kb_answers || []),
      ...newlyAddedQuestions,
    ];

    const allApproved = allQuestions.every((item) => {
      const hasBeenEdited =
        content[item.question_index] !== originalContent[item.question_index] ||
        questions[item.question_index] !==
          originalQuestions[item.question_index] ||
        additionalInfoContent[item.question_index] !== item.additional_info;
      return approvedItems[item.question_index] && !hasBeenEdited;
    });

    return allApproved;
  };

  const handleConfirmApproval = async () => {
    try {
      setIsLoading(true);

      const unapprovedQuestions = [
        ...(kbData?.kb_answers || []),
        ...newlyAddedQuestions,
      ].filter((item) => {
        const hasBeenEdited =
          content[item.question_index] !==
            originalContent[item.question_index] ||
          questions[item.question_index] !==
            originalQuestions[item.question_index];
        return (
          item.status === "Created" ||
          !approvedItems[item.question_index] ||
          hasBeenEdited
        );
      });

      const payload = unapprovedQuestions.map((item) => ({
        question_index: item.question_index,
        question_text: questions[item.question_index] ?? item.question_text,
        answer_text: content[item.question_index] ?? item.answer_text,
        question_category: item.question_category,
        status: "Approved",
      }));

      const response = await makeApiRequest(
        "PUT",
        `kb/${KB_ID}/questions`,
        payload
      );

      if (response) {
        message.success(`Successfully approved ${payload.length} question(s). Your Facebot will be updated soon.`);
        GetKb(); // Refresh the data
      } else {
        message.error("Failed to approve questions");
      }
    } catch (error) {
      console.error("Approve Error:", error);
      message.error("An error occurred while approving the questions");
    } finally {
      setIsLoading(false);
      setIsConfirmModalVisible(false);
    }
  };

  const handleAdditionalInfo = (item) => {
    setSelectedQuestionIndex(item.question_index);
    additionalInfoForm.setFieldsValue({
      additional_info: additionalInfoContent[item.question_index] || "",
    });
    setIsAdditionalInfoModalVisible(true);
  };

  const handleAdditionalInfoSave = async () => {
    try {
      const values = await additionalInfoForm.validateFields();
      const newContent = values.additional_info;

      if (!newContent) {
        message.warning("Please enter additional information");
        return;
      }

      setAdditionalInfoContent((prev) => ({
        ...prev,
        [selectedQuestionIndex]: newContent,
      }));

      // Remove approval when additional info is changed
      setApprovedItems((prev) => {
        const { [selectedQuestionIndex]: removed, ...rest } = prev;
        return rest;
      });

      message.success("Additional information saved successfully");
      setIsAdditionalInfoModalVisible(false);
      checkAllEffectivelyApproved();
    } catch (error) {
      console.error("Error saving additional info:", error);
      message.error("Failed to save additional information");
    }
  };

  const handleDelete = async(item) => {
    try {
      setIsDeleting((prev) => ({ ...prev, [item.question_index]: true }));
      const response = await makeApiRequest("DELETE", `/kb/${item.kb_id}/questions/${item.question_index}`);

      if (response) {
        message.success("Successfully deleted question");
        GetKb();

        setKbData((prevKbData) => {
          if (!prevKbData || !prevKbData.kb_answers) return prevKbData;
          const updatedKbAnswers = prevKbData.kb_answers.filter(
            (answer) => answer.question_index !== item.question_index
          );
          return { ...prevKbData, kb_answers: updatedKbAnswers };
        });

        setContent((prev) => {
          const { [item.question_index]: removed, ...rest } = prev;
          return rest;
        });
        setQuestions((prev) => {
          const { [item.question_index]: removed, ...rest } = prev;
          return rest;
        });
        setApprovedItems((prev) => {
          const { [item.question_index]: removed, ...rest } = prev;
          return rest;
        });
        setOriginalContent((prev) => {
          const { [item.question_index]: removed, ...rest } = prev;
          return rest;
        });
        setOriginalQuestions((prev) => {
          const { [item.question_index]: removed, ...rest } = prev;
          return rest;
        });
        setIsEditing((prev) => {
          const { [item.question_index]: removed, ...rest } = prev;
          return rest;
        });
      } else {
        message.error("Failed to delete question.");
      }


    } catch (error) {
      console.error("Error deleting question:", error);
      message.error("An error occurred while deleting the question.");
    } finally {
      setIsDeleting((prev) => ({ ...prev, [item.question_index]: false }));
    }
  };


  useEffect(() => {
    if (KB_ID) {
      GetKb();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [KB_ID]);


  const GetKb = async() => {
    try {
      setIsLoading(true);
      setCategoriesLoaded(false);
      const response = await makeApiRequest("GET", `kb/${KB_ID}/questions`);

      if (Array.isArray(response)) {
        setKbData({ kb_answers: response });

        const uniqueCategories = [
          ...new Set(response.map((item) => item.question_category)
            .filter((category) => category && category.trim() !== "")
          ),
        ];
        setCategories(uniqueCategories);
        setCategoriesLoaded(true);

        const initialContent = {};
        const initialQuestions = {};
        const initialApprovedItems = {};
        const initialOriginalContent = {};
        const initialOriginalQuestions = {};
        const initialAdditionalInfo = {};

        response.forEach((item) => {
          initialContent[item.question_index] = item.answer_text;
          initialQuestions[item.question_index] = item.question_text;
          initialApprovedItems[item.question_index] = item.status === 'Approved';
          initialOriginalContent[item.question_index] = item.answer_text;
          initialOriginalQuestions[item.question_index] = item.question_text;
          initialAdditionalInfo[item.question_index] = item.additional_info || '';
        });

        setContent(initialContent);
        setQuestions(initialQuestions);
        setApprovedItems(initialApprovedItems);
        setOriginalContent(initialOriginalContent);
        setOriginalQuestions(initialOriginalQuestions);
        setAdditionalInfoContent(initialAdditionalInfo);
        setNewlyAddedQuestions([]);


      } else {
        message.error(
          "Failed to load knowledge base data. Invalid data format received."
        );
        setKbData({ kb_answers: [] });
        setCategories([]);
        setContent({});
        setQuestions({});
        setApprovedItems({});
        setOriginalContent({});
        setOriginalQuestions({});
        setCategoriesLoaded(true);
        setNewlyAddedQuestions([]);
      }
    } catch (error) {
      console.error("GetKb Error:", error);
      message.error("Failed to load knowledge base data.");
      setKbData({ kb_answers: [] });
      setCategories([]);
      setContent({});
      setQuestions({});
      setApprovedItems({});
      setOriginalContent({});
      setOriginalQuestions({});
      setCategoriesLoaded(true);
      setNewlyAddedQuestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const skeletonItems = Array.from({ length: 5 }).map((_, index) => ({
    key: `skeleton-${index}`,
    label: <Skeleton width="80%" />,
    children: (
      <div>
        <Skeleton count={3} />
      </div>
    ),
    extra: <Skeleton circle width={20} height={20} />,
  }));

  const filteredKbAnswers = (selectedCategory && selectedCategory !== "All Categories")
    ? kbData?.kb_answers?.filter(
      (item) =>
        item.question_category === selectedCategory
    )
    : (kbData?.kb_answers || []);

  const items =
        (filteredKbAnswers || []).map((item) => {
          const hasBeenEdited = (content[item.question_index] !== originalContent[item.question_index]) ||
                                 (questions[item.question_index] !== originalQuestions[item.question_index]);
          const isEffectivelyApproved = approvedItems[item.question_index] && !hasBeenEdited;

          return {
            key: item.question_index,
            label: (
              <Text
                editable={{
                  onChange: (value) =>
                    handleQuestionChange(item.question_index, value),
                }}
              >
                {`${item.question_index + 1}. ${(
                  questions[item.question_index] || item.question_text
                ).replace(/^\d+\.\s*/, "")}`}
              </Text>
            ),
            children: (
              <div>
                <Text
                  editable={{
                    onChange: (value) =>
                      handleTextChange(item.question_index, value),
                    triggerType: "icon",
                    icon: <EditOutlined />,
                    tooltip: "Click to edit",
                  }}
                  style={{ display: "block", marginBottom: "10px" }}
                >
                  {content[item.question_index] ?? item.answer_text ?? ""}
                </Text>
                <Flex justify="flex-end" gap={16}>
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => handleAdditionalInfo(item)}
                  >
                    Additional Info
                  </Button>
                  <Button
                    type="primary"
                    danger
                    size="large"
                    loading={isDeleting[item.question_index]}
                    onClick={() => handleDelete(item)}
                    disabled={isDeleting[item.question_index]}
                  >
                    Delete
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    style={{
                      backgroundColor: isEffectivelyApproved
                        ? "gray"
                        : "#2fcc71",
                      color: "white",
                    }}
                    onClick={() => handleApprove(item)}
                    disabled={
                      isEffectivelyApproved || isApproving[item.question_index]
                    }
                    loading={isApproving[item.question_index]}
                  >
                    {isEffectivelyApproved ? "Approved" : "Approve"}
                  </Button>
                </Flex>
                <Modal
                  title="Additional Information"
                  open={isAdditionalInfoModalVisible}
                  onCancel={() => {
                    setIsAdditionalInfoModalVisible(false);
                    additionalInfoForm.resetFields();
                  }}
                  width={800}
                  destroyOnClose
                  footer={[
                    <Button
                      key="cancel"
                      onClick={() => {
                        setIsAdditionalInfoModalVisible(false);
                        additionalInfoForm.resetFields();
                      }}
                    >
                      Cancel
                    </Button>,
                    <Button
                      key="save"
                      type="primary"
                      onClick={handleAdditionalInfoSave}
                    >
                      Save
                    </Button>,
                  ]}
                >
                  <Form
                    form={additionalInfoForm}
                    initialValues={{
                      additional_info:
                        additionalInfoContent[selectedQuestionIndex] || "",
                    }}
                  >
                    <Form.Item
                      name="additional_info"
                      help="You can use HTML tags for formatting"
                    >
                      <Input.TextArea
                        rows={10}
                        placeholder="Enter additional information with HTML formatting..."
                        style={{ fontFamily: "monospace" }}
                      />
                    </Form.Item>
                  </Form>
                  {additionalInfoContent[selectedQuestionIndex] && (
                    <div style={{ marginTop: 16 }}>
                      <Divider>Preview</Divider>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: additionalInfoContent[selectedQuestionIndex],
                        }}
                      />
                    </div>
                  )}
                </Modal>
              </div>
            ),
            extra: isEffectivelyApproved ? (
              <img
                src={CheckMark}
                alt="Approved"
                style={{
                  width: "20px",
                  height: "20px",
                  filter:
                    "invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)",
                }}
              />
            ) : null,
            isNew: false,
          };});

  const newlyAddedItems = newlyAddedQuestions.map(item => {
    const hasBeenEdited = (content[item.question_index] !== originalContent[item.question_index]) ||
                           (questions[item.question_index] !== originalQuestions[item.question_index]);
    const isEffectivelyApproved = approvedItems[item.question_index] && !hasBeenEdited;

    return {
      key: item.question_index,
      label: (
        <Text
          editable={{
            onChange: (value) =>
              handleQuestionChange(item.question_index, value),
          }}
        >
          {`${item.question_index + 1}. ${(
            questions[item.question_index] || item.question_text
          ).replace(/^\d+\.\s*/, "")}`}
        </Text>
      ),
      children: (
        <div>
          <Text
            editable={{
              onChange: (value) => handleTextChange(item.question_index, value),
              triggerType: "icon",
              icon: <EditOutlined />,
              tooltip: "Click to edit",
            }}
            style={{ display: "block", marginBottom: "10px" }}
          >
            {content[item.question_index] ?? item.answer_text ?? ""}
          </Text>
          <Flex justify="flex-end" gap={16}>
            <Button
              type="primary"
              size="large"
              onClick={() => handleAdditionalInfo(item)}
            >
              Additional Info
            </Button>
            <Button
              type="primary"
              danger
              size="large"
              loading={isDeleting[item.question_index]}
              onClick={() => handleDelete(item)}
              disabled={isDeleting[item.question_index]}
            >
              Delete
            </Button>
            <Button
              type="primary"
              size="large"
              style={{
                backgroundColor: isEffectivelyApproved ? "gray" : "#2fcc71",
                color: "white",
              }}
              onClick={() => handleApprove(item)}
              disabled={
                isEffectivelyApproved || isApproving[item.question_index]
              }
              loading={isApproving[item.question_index]}
            >
              {isEffectivelyApproved ? "Approved" : "Approve"}
            </Button>
          </Flex>
        </div>
      ),
      extra: isEffectivelyApproved ? (
        <img
          src={CheckMark}
          alt="Approved"
          style={{
            width: "20px",
            height: "20px",
            filter:
              "invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)",
          }}
        />
      ) : null,
    };
  });

  const handleAddQuestion = () => {
    form.resetFields();
    setOpenAddQuestionModal(true);
  };

  const handleAddQuestionModalOk = async() => {
    try {
      const values = await form.validateFields();
      setIsLoading(true);

      const existingMaxIndex = kbData?.kb_answers?.length > 0
      ? Math.max(...kbData.kb_answers.map(item => item.question_index))
      : 0;
    
      const newlyAddedMaxIndex = newlyAddedQuestions.length > 0
      ? Math.max(...newlyAddedQuestions.map(item => item.question_index))
      : 0;
      const nextQuestionIndex = Math.max(existingMaxIndex, newlyAddedMaxIndex) + 1;

      const payload = {
        question_index: nextQuestionIndex,
        question_text: values.question,
        answer_text: values.answer,
        question_category: values.category,
        status: "Created",
      };

      const response = await makeApiRequest(
        "POST",
        `kb/${KB_ID}/questions`,
        payload
      );

      if (response) {
        message.success("Successfully added new question. Approve it to update the Facebot.");

        const newItem = {
          ...payload,
          kb_id: KB_ID,
        };
        setNewlyAddedQuestions((prev) => [newItem, ...prev]);
        // setApprovedItems((prev) => ({ ...prev, [payload.question_index]: true }));

        // const updatedKbAnswers = kbData?.kb_answers ? [newItem, ...kbData.kb_answers] : [newItem];
        // setKbData((prev) => ({
        //   ...prev,
        //   kb_answers: updatedKbAnswers,
        // }));

        setContent((prevContent) => ({
          ...prevContent,
          [nextQuestionIndex]: payload.answer_text,
        }));

        setQuestions((prevQuestions) => ({
          ...prevQuestions,
          [nextQuestionIndex]: payload.question_text,
        }));

        setOriginalContent((prevOriginalContent) => ({
          ...prevOriginalContent,
          [nextQuestionIndex]: payload.answer_text,
        }));

        setOriginalQuestions((prevOriginalQuestions) => ({
          ...prevOriginalQuestions,
          [nextQuestionIndex]: payload.question_text,
        }));

        setOpenAddQuestionModal(false);

      } else {
        message.error("Failed to add new question");
      }
    } catch (errorInfo) {
      if (errorInfo.errorFields) {
        console.log('Validation Failed:', errorInfo);
      } else {
        console.error("Error adding new question:", errorInfo);
        message.error("An error occurred while adding the question.");
      }
    } finally {
      setIsLoading(false);

    }
  };

  const handleAddQuestionModalCancel = () => {
    setOpenAddQuestionModal(false);
    form.resetFields();
  };

  const getUploadUrl = async (file) => {
    const newUuid = uuidv4();
  
    const params = {
      file_id: newUuid.slice(0, 8),
      file_type: fileTypeMap[file.type] || file.type.split("/")[1],
    };
  
    return await makeApiRequest("POST", "kb/requestUploadUrl", params);
  };
  const handleContinueUpload = async () => {
    setIsProcessingModalVisible(true);
    const initialQuestionCount = kbData?.kb_answers?.length || 0;
      if (fileList.length === 0) {
        message.error('Please select a file first');
        return;
      }

      const file = fileList[0];
      if (!file || !(file instanceof File || file instanceof Blob)) {
        message.error("Invalid file object. Please select a file again.");
        setFileList([]);
        setSelectedFileName("");
        return;
      }
      
      setUploadLoading(true);
      const uploadData = await getUploadUrl(file);
      
      if (!uploadData) {
        message.error('Failed to get upload URL');
        setUploadLoading(false);
        return;
      }
      
      const formData = new FormData();

      // Append the fields to the form data
      if (uploadData.fields) {
        for (const key in uploadData.fields) {
          formData.append(key, uploadData.fields[key]);
        }
      }

      try {
        formData.append('file', file, file.name || 'uploaded-file');
      } catch (formDataError) {
        console.error('FormData append error:', formDataError);
        message.error('Failed to prepare file for upload. Please try again.');
        setUploadLoading(false);
        return;
      }
  
      await axios.post(uploadData.url, formData, {
        headers: {
        },
        transformRequest: [function (data) {
          return data; // Don't transform FormData
        }],
      });
      console.log(uploadData.url, "url");
      console.log(uploadData.fields.key, "key");
      
      const fileUrl = `${uploadData.url}${uploadData.fields.key}`;
      console.log(fileUrl);
      await makeApiRequest("PUT", `kb/${KB_ID}`, { 
        kb_file_urls: [fileUrl], 
        kb_name: kbName,
        kb_description: kbDescription,
      });
      
      message.success('File uploaded successfully');
      try {
        const checkKBStatus = async (retries = 0) => {
          if (retries > 30) {
            message.error("Processing timed out. Please try again later.");
            setIsProcessingModalVisible(false);
            setOpenAddQuestionModal(false);
            return;
          }
          try {
            const response = await makeApiRequest("GET", `kb/${KB_ID}`);
            const newQuestionCount = response?.kb_answers?.length || 0;
            if (response && response.progress === 100 && response.kb_status === 'COMPLETED') {
              if (newQuestionCount > initialQuestionCount) {
                message.success('Questions added successfully!');
              }
              GetKb();
              setIsProcessingModalVisible(false);
              setOpenAddQuestionModal(false);
            } else {
              setTimeout(() => checkKBStatus(retries + 1), 2000);
            }
          } catch (err) {
            message.error("An error occurred while checking processing status.");
            setIsProcessingModalVisible(false);
            setOpenAddQuestionModal(false);
          }
        };
        await checkKBStatus();
      } catch (error) {
        message.error('Failed to upload file: ' + (error.response?.data?.message || error.message));
        setIsProcessingModalVisible(false);
        setOpenAddQuestionModal(false);
      } finally {
        setUploadLoading(false);
        setFileList([]);
        setSelectedFileName('');
      }
    };
  
  const draggerProps = {
    accept: '.pdf,.doc,.docx,.txt,.html',
    fileList: fileList,
    beforeUpload: (file) => {
      const maxSize = 1 * 1024 * 1024;
      const allowedTypes = {
        'application/pdf': 'pdf',
        'text/html': 'html',
        'text/plain': 'txt',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
      };

      if (!Object.keys(allowedTypes).includes(file.type)) {
        message.error("Invalid file type. Only PDF, HTML, TXT, and Word files are allowed.");
        return false;
      }

      if (file.size > maxSize) {
        message.error("File size must be 1MB or less. Please try again!");
        return false;
      }

      if (!(file instanceof File)) {
        message.error("Invalid file object. Please try again.");
        return false;
      }

      setSelectedFileName(file.name);
      setFileList([file]);
      return false;
    },
    showUploadList: false,
    onChange(info) {
      // Ensure we're getting a valid file object
      if (info.fileList.length > 0) {
        const file = info.fileList[info.fileList.length - 1];
        if (file && file.originFileObj) {
          setFileList([file.originFileObj]);
        } else if (file && (file instanceof File || file instanceof Blob)) {
          setFileList([file]);
        }
      } else {
        setFileList([]);
      }
    }
  };

  const inputRef = useRef(null);

  const onNameChange = (event) => {
    setNewCategory(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (newCategory.trim()) {
      setCategories([...categories, newCategory]);
      setNewCategory('');
    }

    const trimmedCategory = newCategory.trim();

    if (trimmedCategory && !categories.includes(trimmedCategory)) {
      const updatedCategories = [...categories, trimmedCategory];
      setCategories(updatedCategories);

      form.setFieldsValue({ category: trimmedCategory });

      setNewCategory("");

      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);

      message.success("Successfully added new category");
    } else if (categories.includes(trimmedCategory)) {
      message.warning("Category already exists");
    } else {
      message.warning("Please enter a category name");
    }
  };


  return (
    <div className={styles.container}>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={14}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <EditOutlined style={{ fontSize: "16px", color: "#ff692e" }} />
            <Title
              level={3}
              style={{ fontWeight: "normal", marginTop: "10px" }}
            >
              {isLoading && !kbData ? (
                <Skeleton width={200} />
              ) : (
                "Knowledge Verification & Editing"
              )}
            </Title>
            <Tooltip
              title={
                <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                  <div
                    style={{
                      marginBottom: "8px",
                      fontWeight: "500",
                      color: "#ff692e",
                    }}
                  >
                    Knowledge Base Management
                  </div>
                  <div style={{ marginBottom: "8px", color: "#21130d" }}>
                    Review, Edit and verify your knowledge base content with
                    precision
                  </div>
                  <ul
                    style={{
                      margin: "0",
                      paddingLeft: "16px",
                      color: "#21130d",
                    }}
                  >
                    <li>Edit questions and answers in real-time.</li>
                    <li>Approve items individually or in bulk by category.</li>
                    <li>
                      Track facebot generation status in{" "}
                      <Text mark style={{ padding: "2px 4px" }}>
                        Facebot
                      </Text>{" "}
                      Menu.
                    </li>
                  </ul>
                </div>
              }
              placement="right"
              color="#ffffff"
            >
              <QuestionCircleOutlined
                style={{
                  fontSize: "18px",
                  color: "#1677ff",
                  cursor: "pointer",
                  marginTop: "4px",
                }}
              />
            </Tooltip>
          </div>
          {isLoading && !kbData ? (
            <Skeleton count={2} />
          ) : (
            <Text className={styles.description}>
              This process involves thoroughly reviewing and confirming the
              accuracy, relevance, and completeness of information related to
              your products, services, or processes. It ensures that all data is
              up-to-date, factual, and aligned with your objectives. The editing
              phase focuses on refining the content for clarity, consistency,
              and proper structure, ensuring it is presented in a professional,
              easy-to-understand manner. This step is crucial for maintaining
              the integrity of your materials, boosting credibility, and
              facilitating effective communication.
            </Text>
          )}

          <Title level={4} style={{ fontWeight: "normal", marginTop: "4rem" }}>
            {isLoading && !kbData ? (
              <Skeleton width={250} />
            ) : (
              "Key Findings on Product / Service Performance"
            )}
          </Title>

          <Flex wrap className={styles.cardContainer}>
            {isLoading && !categoriesLoaded
              ? Array.from({ length: 2 }).map((_, index) => (
                  <div
                    className={styles.card}
                    key={index}
                    style={{
                      padding: "20px",
                      border: "1px solid #f0f0f0",
                      borderRadius: "8px",
                      minWidth: "150px",
                    }}
                  >
                    <Skeleton
                      height={20}
                      width={100}
                      style={{ marginBottom: "10px" }}
                    />
                    <Skeleton height={30} width={50} />
                  </div>
                ))
              : cardItems.map((item, index) => (
                  <div className={styles.card} key={index}>
                    <Space>
                      {item.icon}
                      <Text className={styles.cardTitle}>{item.title}</Text>
                    </Space>
                    <Title level={2} className={styles.cardValue}>
                      {item.value}
                    </Title>
                  </div>
                ))}
          </Flex>

          <Title
            level={4}
            style={{
              fontWeight: "normal",
              marginTop: "4rem",
              marginBottom: "1rem",
            }}
          >
            {isLoading && !kbData ? (
              <Skeleton width={400} />
            ) : (
              <span>
                Please verify the contents to ensure accuracy & completeness.
                <br />
                You can approve items individually or by category.
              </span>
            )}
          </Title>

          <Space wrap style={{ marginBottom: "2rem" }}>
            {isLoading && !categoriesLoaded ? (
              <Skeleton width={200} height={40} />
            ) : (
              <Select
                showSearch
                placeholder="Select a category"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={selectedCategory}
                onChange={onChange}
                options={options}
                allowClear
                size="large"
                style={{ width: "20rem" }}
              />
            )}
            <Button
              type="primary"
              size="large"
              style={{ width: "10rem" }}
              onClick={handleApproveAll}
              disabled={isLoading || !selectedCategory}
            >
              Approve Category
            </Button>

            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              style={{ width: "10rem" }}
              onClick={handleAddQuestion}
              disabled={isLoading}
            >
              Add Question
            </Button>
          </Space>

          {newlyAddedQuestions.length > 0 && (
            <div className={styles.approveCard}>
              <Title level={5}>Newly Added Questions</Title>
              <Collapse
                activeKey={activeKeys}
                onChange={handleCollapseChange}
                expandIconPosition="end"
                size="large"
                items={newlyAddedItems}
              />
            </div>
          )}

          <div className={styles.approveCard}>
            <Title level={5}>All Questions</Title>
            <Collapse
              activeKey={activeKeys}
              onChange={handleCollapseChange}
              expandIconPosition="end"
              size="large"
              items={isLoading && !kbData ? skeletonItems : items}
            />
          </div>
        </Col>
      </Row>

      {!isLoading && kbData && (
        <div className={styles.hoverFooterWrapper}>
          <div>
            <Title
              level={4}
              style={{ margin: 0, fontWeight: "normal", color: "gray" }}
            >
              Knowledge Base Summary
            </Title>
          </div>

          <span className={styles.sectionShadow} />

          <div className={styles.section}>
            <Title level={3} style={{ margin: 0, fontWeight: "normal" }}>
              {!categoriesLoaded ? (
                <Skeleton width={30} inline />
              ) : (
                categories?.length || 0
              )}
            </Title>
            <LuLayoutDashboard
              size={22}
              color="gray"
              style={{ marginLeft: "8px", marginRight: "4px" }}
            />
            <Text style={{ color: "gray" }}>Categories</Text>
          </div>

          <div className={styles.section}>
            <Title
              level={3}
              style={{
                margin: 0,
                fontWeight: "normal",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {getQuestionStatusCounts().total}
              <FaRegQuestionCircle
                size={22}
                color="gray"
                style={{ marginLeft: "4px" }}
              />
              <Text style={{ color: "gray", marginLeft: "4px" }}>
                Questions
              </Text>
            </Title>
            {getQuestionStatusCounts().created > 0 && (
              <Tooltip
                title="Click to update your facebot with newly added and edited questions"
                placement="top"
              >
                <Button
                  type="primary"
                  danger
                  size="large"
                  style={{
                    padding: "0 8px",
                    height: "24px",
                    fontSize: "14px",
                  }}
                  onClick={handleUnapprovedClick}
                >
                  Unapproved ({getQuestionStatusCounts().created})
                </Button>
              </Tooltip>
            )}
            <Modal
              title="Approve Unapproved Questions"
              open={isConfirmModalVisible}
              onOk={handleConfirmApproval}
              onCancel={() => setIsConfirmModalVisible(false)}
              confirmLoading={isLoading}
            >
              <p style={{ marginBottom: "1em" }}>
                Are you sure you want to save all edited, or newly added
                questions?
              </p>
              <p
                style={{
                  color: "#52c41a",
                  marginTop: "1em",
                  fontStyle: "bold",
                }}
              >
                Don't worry, your Widget will work while updation.
              </p>
            </Modal>
            <Modal
              open={isProcessingModalVisible}
              footer={null}
              closable={false}
              centered
            >
              <div style={{ textAlign: "center", padding: 32 }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>
                  <Typography.Text>
                    Processing your file and generating questions. This may take
                    a minute...
                  </Typography.Text>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      )}

      <Modal
        open={openAddQuestionModal}
        onCancel={handleAddQuestionModalCancel}
        footer={
          activeTab === "single" ? (
            <>
              <Button key="back" onClick={handleAddQuestionModalCancel}>
                Cancel
              </Button>
              <Button
                key="submit"
                type="primary"
                loading={isLoading}
                onClick={() =>
                  form.validateFields().then(handleAddQuestionModalOk)
                }
              >
                Add Question
              </Button>
            </>
          ) : (
            <Button
              key="continue"
              type="primary"
              loading={uploadLoading}
              disabled={uploadLoading}
              onClick={handleContinueUpload}
            >
              Continue
            </Button>
          )
        }
      >
        <Form form={form} layout="vertical" name="add_question_form">
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <TabPane tab="Add Question" key="single">
              <Form.Item
                name="question"
                label="Question"
                rules={[
                  { required: true, message: "Please input the question!" },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Enter your question here..."
                />
              </Form.Item>
              <Form.Item
                name="answer"
                label="Answer"
                rules={[
                  { required: true, message: "Please input the answer!" },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Enter the answer here..."
                />
              </Form.Item>
              <Form.Item
                name="category"
                label="Category"
                rules={[
                  { required: true, message: "Please select a category!" },
                ]}
              >
                <Select
                  placeholder="Select or add a category"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: "8px 0" }} />
                      <Space style={{ padding: "0 8px 4px" }}>
                        <Input
                          placeholder="Add new category"
                          ref={inputRef}
                          value={newCategory}
                          onChange={onNameChange}
                          onKeyDown={(e) => e.stopPropagation()}
                          onPressEnter={addItem}
                        />
                        <Button
                          type="text"
                          icon={<PlusOutlined />}
                          onClick={addItem}
                        >
                          Add
                        </Button>
                      </Space>
                    </>
                  )}
                >
                  {categories.map((category) => (
                    <Select.Option key={category} value={category}>
                      {category}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </TabPane>
            <TabPane tab="AI Generate" key="upload">
              <Dragger {...draggerProps}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  {selectedFileName || "Click or drag file to upload"}
                </p>
                <p className="ant-upload-hint">
                  Support for PDF, HTML, TXT, Word files
                  <br />
                  Format: Question | Answer | Category (Optional)
                  <br />
                  Max file size: 1MB
                </p>
              </Dragger>
            </TabPane>
          </Tabs>
        </Form>
      </Modal>
    </div>
  );
};

export default ContentKB;